import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _classPrivateFieldGet from "@babel/runtime/helpers/classPrivateFieldGet";
import _classPrivateFieldSet from "@babel/runtime/helpers/classPrivateFieldSet";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { getConfigurationValue } from '../config/init';
import { isFileProtocol } from '../url/protocol';
import { warn } from './console';
/**
 * Represents an obfuscation rule that can be applied to harvested payloads
 * @typedef {object} ObfuscationRule
 * @property {string|RegExp} regex The regular expression to match against in the payload
 * @property {string} [replacement] The string to replace the matched regex with
 */

/**
 * Represents an obfuscation rule validation state
 * @typedef {object} ObfuscationRuleValidation
 * @property {ObfuscationRule} rule The original rule validated
 * @property {boolean} isValid Whether the rule is valid
 * @property {object} errors Validation errors
 * @property {boolean} errors.regexMissingDetected Whether the regex is missing
 * @property {boolean} errors.invalidRegexDetected Whether the regex is invalid
 * @property {boolean} errors.invalidReplacementDetected Whether the replacement is invalid
 */

var _ruleValidationCache = /*#__PURE__*/new WeakMap();

export var Obfuscator = /*#__PURE__*/function () {
  /**
   * @type {ObfuscationRuleValidation[]}
   */
  function Obfuscator(agentIdentifier) {
    _classCallCheck(this, Obfuscator);

    _ruleValidationCache.set(this, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldSet(this, _ruleValidationCache, Obfuscator.getRuleValidationCache(agentIdentifier));

    Obfuscator.logObfuscationRuleErrors(_classPrivateFieldGet(this, _ruleValidationCache));
  }

  _createClass(Obfuscator, [{
    key: "ruleValidationCache",
    get: function get() {
      return _classPrivateFieldGet(this, _ruleValidationCache);
    }
    /**
     * Applies all valid obfuscation rules to the provided input string
     * @param {string} input String to obfuscate
     * @returns {string}
     */

  }, {
    key: "obfuscateString",
    value: function obfuscateString(input) {
      // if input is not of type string or is an empty string, short-circuit
      if (typeof input !== 'string' || input.trim().length === 0) return input;
      return _classPrivateFieldGet(this, _ruleValidationCache).filter(function (ruleValidation) {
        return ruleValidation.isValid;
      }).reduce(function (input, ruleValidation) {
        var rule = ruleValidation.rule;
        return input.replace(rule.regex, rule.replacement || '*');
      }, input);
    }
    /**
     * Returns an array of obfuscation rules to be applied to harvested payloads
     * @param {string} agentIdentifier The agent identifier to get rules for
     * @returns {ObfuscationRuleValidation[]} The array of rules or validation states
     */

  }], [{
    key: "getRuleValidationCache",
    value: function getRuleValidationCache(agentIdentifier) {
      /**
       * @type {ObfuscationRule[]}
       */
      var rules = getConfigurationValue(agentIdentifier, 'obfuscate') || [];

      if (isFileProtocol()) {
        rules.push({
          regex: /^file:\/\/(.*)/,
          replacement: atob('ZmlsZTovL09CRlVTQ0FURUQ=')
        });
      }

      return rules.map(function (rule) {
        return Obfuscator.validateObfuscationRule(rule);
      });
    }
    /**
     * Validates an obfuscation rule and provides errors if any are found.
     * @param {ObfuscationRule} rule The rule to validate
     * @returns {ObfuscationRuleValidation} The validation state of the rule
     */

  }, {
    key: "validateObfuscationRule",
    value: function validateObfuscationRule(rule) {
      var regexMissingDetected = Boolean(rule.regex === undefined);
      var invalidRegexDetected = Boolean(rule.regex !== undefined && typeof rule.regex !== 'string' && !(rule.regex instanceof RegExp));
      var invalidReplacementDetected = Boolean(rule.replacement && typeof rule.replacement !== 'string');
      return {
        rule: rule,
        isValid: !regexMissingDetected && !invalidRegexDetected && !invalidReplacementDetected,
        errors: {
          regexMissingDetected: regexMissingDetected,
          invalidRegexDetected: invalidRegexDetected,
          invalidReplacementDetected: invalidReplacementDetected
        }
      };
    }
    /**
     * Logs any obfuscation rule errors to the console. This is called when an obfuscator
     * instance is created.
     * @param {ObfuscationRuleValidation[]} ruleValidationCache The cache of rule validation states
     */

  }, {
    key: "logObfuscationRuleErrors",
    value: function logObfuscationRuleErrors(ruleValidationCache) {
      var _iterator = _createForOfIteratorHelper(ruleValidationCache),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var ruleValidation = _step.value;
          var rule = ruleValidation.rule,
              isValid = ruleValidation.isValid,
              errors = ruleValidation.errors;
          if (isValid) continue;
          if (errors.regexMissingDetected) warn(12, rule);else if (errors.invalidRegexDetected) warn(13, rule);
          if (errors.invalidReplacementDetected) warn(14, rule);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);

  return Obfuscator;
}();